import { render, staticRenderFns } from "./SummaryMetric.vue?vue&type=template&id=5684bc7a&scoped=true"
import script from "./SummaryMetric.vue?vue&type=script&lang=js"
export * from "./SummaryMetric.vue?vue&type=script&lang=js"
import style0 from "./SummaryMetric.vue?vue&type=style&index=0&id=5684bc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684bc7a",
  null
  
)

export default component.exports